import { takeEvery, call, put } from 'redux-saga/effects'
import { SubmissionError } from 'redux-form'

import {
  updateUsernameRecovery,
  errorUsername,
  USERNAME_RECOVERY_POST,
} from 'actions/username'
import { logInteraction } from 'util/log-interaction'

function _postUsernameRecovery({ create }, logError) {
  return function*(action) {
    try {
      logInteraction('recover username')
      const accountEndpoint = '/auth/forgotUsername'

      const values = action.payload.values

      yield call(create, accountEndpoint, values)

      yield put(updateUsernameRecovery())

      yield call(action.payload.resolve)
    } catch (err) {
      yield call(logError, err)

      const data =
        err.status === 400 && err.responseText
          ? JSON.parse(err.responseText)
          : null
      const errorData = data.msg

      if (errorData) {
        yield call(
          action.payload.reject,
          new SubmissionError({ _error: errorData })
        )
      } else {
        yield call(action.payload.reject)
      }

      yield put(
        errorUsername({
          error: true,
          data: data,
        })
      )
    }
  }
}

export const Test = {
  _postUsernameRecovery,
}

// Watchers
// ---------------------------------------------------------------------------
export function* watchPostUsernameRecovery(api, error) {
  yield takeEvery(USERNAME_RECOVERY_POST, _postUsernameRecovery(api, error))
}
